export default "__VITE_ASSET__dlxJqxKmjmgf0BwBxD_HNA__ 480w, __VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__ 745w";